module.exports = __webpack_public_path__ + "img/standard-icon1.6d17e4e.svg";